import Vue from 'vue'
import Router from 'vue-router'
import Login from '@/components/login.vue'
import ExamList from '@/components/exam_list.vue'
import RegisteTeacher from '@/components/registe_teacher.vue'
import ExamDetail from '@/components/exam_detail.vue'
import ExamEdit from '@/components/exam_edit.vue'
import ExamImport from '@/components/exam_import.vue'
import ExamImportAnyFile from '@/components/exam_import_anyfile.vue'
import ExamExcelPreview from '@/components/exam_excel_preview.vue'
import ExamExcelFinalPreview from '@/components/exam_excel_final_preview.vue'
import ScoreAdd from '@/components/score_add.vue'
import StudentList from '@/components/student_list.vue'
import SearchResultSettings from '@/components/search_result_settings.vue'
import Help from '@/components/help.vue'
import HelpList from '@/components/help_list.vue'
import HelpAdd from '@/components/help_add.vue'
import ExamNew from '@/components/exam_new.vue'
import ConnectService from '@/components/connect_service.vue'

import StudentImportAnyFile from '@/components/student_import_anyfile.vue'
import StudentExcelPreview from '@/components/student_excel_preview.vue'
import StudentExcelFinalPreview from '@/components/student_excel_final_preview.vue'

import CoursesList from '@/components/courses_list.vue'

import ReadMe from '@/components/read_me.vue'
import GoodsList from '@/components/goods_list.vue'
import GoodsEdit from '@/components/goods_edit.vue'

// import HowToSwitch from '@/components/how_to_switch.vue'

// 高级设置
import SearchCondition from '@/components/search_condition.vue'
import PointSetting from '@/components/point_settings.vue'

// 新增的导入功能
import ExamImportAnyFileEx from '@/components/exam_import_anyfile_ex.vue'
import ExamExcelPreviewEx from '@/components/exam_excel_preview_ex.vue'
import ExamExcelFinalPreviewEx from '@/components/exam_excel_final_preview_ex.vue'

// 直播相关
import LiveClass from '@/components/live_class.vue'

// 团队协作
import TeamExamList from '@/components/team_exam_list.vue'
import TeamExamNew from '@/components/team_exam_new.vue'
import TeamExamDetail from '@/components/team_exam_detail.vue'
import TeamExamImportAnyFileEx from '@/components/team_exam_import_anyfile_ex.vue'
import TeamExamExcelPreviewEx from '@/components/team_exam_excel_preview_ex.vue'
import TeamExamExcelFinalPreviewEx from '@/components/team_exam_excel_final_preview_ex.vue'
import TeamStudentsGroupList from '@/components/team_students_group_list.vue'
import TeamStudentsGroupNew from '@/components/team_students_group_new.vue'
import TeamStudentsGroupDetail from '@/components/team_students_group_detail.vue'
import TeamStudentImportAnyFile from '@/components/team_student_import_anyfile.vue'
import TeamStudentExcelPreview from '@/components/team_student_excel_preview.vue'
import TeamStudentExcelFinalPreview from '@/components/team_student_excel_final_preview.vue'

import ExamEditHtml from '@/components/exam_edit_html.vue'


import ExamScoreImportAnyfile from '@/components/exam_score_import_anyfile.vue'
import ExamScoreExcelPreview from '@/components/exam_score_excel_preview.vue'
import ExamScoreExcelFinalPreview from '@/components/exam_score_excel_final_preview.vue'


//合并成绩单
import MergeExamReadMe from '@/components/merge_exam_read_me.vue'
import TeamExamImportAnyFile from '@/components/team_exam_import_anyfile.vue'

import TeamExamExcelPreview from '@/components/team_exam_excel_preview.vue'
import TeamExamExcelFinalPreview from '@/components/team_exam_excel_final_preview.vue'


// import MergeExamFromExcel from '@/components/merge_exam_from_excel.vue'
// import MergeExamNew from '@/components/merge_exam_new.vue'

//助教增收
import HelpTeacherXhs from '@/components/help_teacher_xhs.vue'

//短信提醒
import ShortMessageSetting from '@/components/short_message_setting.vue'


import AddToPubsite from '@/components/add_to_pubsite.vue'


import ExamReport from '@/components/exam_report.vue'


//运营管理
import CompetitionList from '@/components/competition_list.vue'
import CompetitionEdit from '@/components/competition_edit.vue'
import CompetitionManager from '@/components/competition_manager.vue'

import CompetitionGroupEdit from '@/components/competition_group_edit.vue'


// 解决ElementUI导航栏中的vue-router在3.0版本以上重复点菜单报错问题
const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

Vue.use(Router)

export default new Router({
  routes: [{
      path: '/',
      name: 'Login',
      component: Login,
      meta: {
        title: '发布成绩|成绩发布|查分|查成绩|快查成绩|成绩导入系统'
      }
    },
    {
      path: '/exam_list',
      name: 'examList',
      component: ExamList,
      meta: {
        title: '发布成绩|成绩发布|查分|查成绩|快查成绩|成绩导入系统'
      }
    },
    {
      path: '/registe_teacher',
      name: 'registe_teacher',
      component: RegisteTeacher,
      meta: {
        title: '发布成绩|成绩发布|查分|查成绩|快查成绩|成绩导入系统'
      }
    },
    {
      path: '/exam_detail',
      name: 'exam_detail',
      component: ExamDetail,
      meta: {
        title: '发布成绩|成绩发布|查分|查成绩|快查成绩|成绩导入系统'
      }
    },
    {
      path: '/exam_edit',
      name: 'exam_edit',
      component: ExamEdit,
      meta: {
        title: '发布成绩|成绩发布|查分|查成绩|快查成绩|成绩导入系统'
      }
    },
    {
      path: '/exam_import',
      name: 'exam_import',
      component: ExamImport,
      meta: {
        title: '发布成绩|成绩发布|查分|查成绩|快查成绩|成绩导入系统'
      }
    },
    {
      path: '/exam_import_anyfile',
      name: 'exam_import_anyfile',
      component: ExamImportAnyFile,
      meta: {
        title: '发布成绩|成绩发布|查分|查成绩|快查成绩|成绩导入系统'
      }
    },
    {
      path: '/exam_excel_preview',
      name: 'exam_excel_preview',
      component: ExamExcelPreview,
      meta: {
        title: '发布成绩|成绩发布|查分|查成绩|快查成绩|成绩导入系统'
      }
    },
    {
      path: '/exam_excel_final_preview',
      name: 'exam_excel_final_preview',
      component: ExamExcelFinalPreview,
      meta: {
        title: '发布成绩|成绩发布|查分|查成绩|快查成绩|成绩导入系统'
      }
    },
    {
      path: '/score_add',
      name: 'score_add',
      component: ScoreAdd,
      meta: {
        title: '发布成绩|成绩发布|查分|查成绩|快查成绩|成绩导入系统'
      }
    },
    {
      path: '/student_list',
      name: 'student_list',
      component: StudentList,
      meta: {
        title: '发布成绩|成绩发布|查分|查成绩|快查成绩|成绩导入系统'
      }
    },
    {
      path: '/help',
      name: 'help',
      component: Help,
      meta: {
        title: '发布成绩|成绩发布|查分|查成绩|快查成绩|成绩导入系统'
      }
    },
    {
      path: '/help_list',
      name: 'help_list',
      component: HelpList,
      meta: {
        title: '发布成绩|成绩发布|查分|查成绩|快查成绩|成绩导入系统'
      }
    },
    {
      path: '/help_add',
      name: 'help_add',
      component: HelpAdd,
      meta: {
        title: '发布成绩|成绩发布|查分|查成绩|快查成绩|成绩导入系统'
      }
    },
    {
      path: '/search_result_settings',
      name: 'search_result_settings',
      component: SearchResultSettings,
      meta: {
        title: '发布成绩|成绩发布|查分|查成绩|快查成绩|成绩导入系统'
      }
    },

    {
      path: '/exam_new',
      name: 'exam_new',
      component: ExamNew,
      meta: {
        title: '发布成绩|成绩发布|查分|查成绩|快查成绩|成绩导入系统'
      }
    },

    {
      path: '/connect_service',
      name: 'connect_service',
      component: ConnectService,
      meta: {
        title: '发布成绩|成绩发布|查分|查成绩|快查成绩|成绩导入系统'
      }
    },
    {
      path: '/student_import_anyfile',
      name: 'student_import_anyfile',
      component: StudentImportAnyFile,
      meta: {
        title: '发布成绩|成绩发布|查分|查成绩|快查成绩|成绩导入系统'
      }
    },
    {
      path: '/student_excel_preview',
      name: 'student_excel_preview',
      component: StudentExcelPreview,
      meta: {
        title: '发布成绩|成绩发布|查分|查成绩|快查成绩|成绩导入系统'
      }
    },
    {
      path: '/student_excel_final_preview',
      name: 'student_excel_final_preview',
      component: StudentExcelFinalPreview,
      meta: {
        title: '发布成绩|成绩发布|查分|查成绩|快查成绩|成绩导入系统'
      }
    },
    {
      path: '/courses_list',
      name: 'courses_list',
      component: CoursesList,
      meta: {
        title: '发布成绩|成绩发布|查分|查成绩|快查成绩|成绩导入系统'
      }
    },
    {
      path: '/read_me',
      name: 'read_me',
      component: ReadMe,
      meta: {
        title: '发布成绩|成绩发布|查分|查成绩|快查成绩|成绩导入系统'
      }
    },
    {
      path: '/goods_list',
      name: 'goods_list',
      component: GoodsList,
      meta: {
        title: '发布成绩|成绩发布|查分|查成绩|快查成绩|成绩导入系统'
      }
    },
    {
      path: '/goods_edit',
      name: 'goods_edit',
      component: GoodsEdit,
      meta: {
        title: '发布成绩|成绩发布|查分|查成绩|快查成绩|成绩导入系统'
      }
    },
    {
      path: '/search_condition',
      name: 'search_condition',
      component: SearchCondition,
      meta: {
        title: '发布成绩|成绩发布|查分|查成绩|快查成绩|成绩导入系统'
      }
    },
    {
      path: '/point_setting',
      name: 'point_setting',
      component: PointSetting,
      meta: {
        title: '发布成绩|成绩发布|查分|查成绩|快查成绩|成绩导入系统'
      }
    },
    {
      path: '/exam_import_anyfile_ex',
      name: 'exam_import_anyfile_ex',
      component: ExamImportAnyFileEx,
      meta: {
        title: '发布成绩|成绩发布|查分|查成绩|快查成绩|成绩导入系统'
      }
    },
    {
      path: '/exam_excel_preview_ex',
      name: 'exam_excel_preview_ex',
      component: ExamExcelPreviewEx,
      meta: {
        title: '发布成绩|成绩发布|查分|查成绩|快查成绩|成绩导入系统'
      }
    },
    {
      path: '/exam_excel_final_preview_ex',
      name: 'exam_excel_final_preview_ex',
      component: ExamExcelFinalPreviewEx,
      meta: {
        title: '发布成绩|成绩发布|查分|查成绩|快查成绩|成绩导入系统'
      }
    },

    {
      path: '/live_class',
      name: 'live_class',
      component: LiveClass,
      meta: {
        title: '发布成绩|成绩发布|查分|查成绩|快查成绩|成绩导入系统'
      }
    },
    {
      path: '/team_exam_list',
      name: 'team_exam_list',
      component: TeamExamList,
      meta: {
        title: '发布成绩|成绩发布|查分|查成绩|快查成绩|成绩导入系统'
      }
    },

    {
      path: '/team_exam_new',
      name: 'team_exam_new',
      component: TeamExamNew,
      meta: {
        title: '发布成绩|成绩发布|查分|查成绩|快查成绩|成绩导入系统'
      }
    },
    {
      path: '/team_exam_detail',
      name: 'team_exam_detail',
      component: TeamExamDetail,
      meta: {
        title: '发布成绩|成绩发布|查分|查成绩|快查成绩|成绩导入系统'
      }
    },
    {
      path: '/team_exam_import_anyfile_ex',
      name: 'team_exam_import_anyfile_ex',
      component: TeamExamImportAnyFileEx,
      meta: {
        title: '发布成绩|成绩发布|查分|查成绩|快查成绩|成绩导入系统'
      }
    },
    {
      path: '/team_exam_excel_preview_ex',
      name: 'team_exam_excel_preview_ex',
      component: TeamExamExcelPreviewEx,
      meta: {
        title: '发布成绩|成绩发布|查分|查成绩|快查成绩|成绩导入系统'
      }
    },
    {
      path: '/team_exam_excel_final_preview_ex',
      name: 'team_exam_excel_final_preview_ex',
      component: TeamExamExcelFinalPreviewEx,
      meta: {
        title: '发布成绩|成绩发布|查分|查成绩|快查成绩|成绩导入系统'
      }
    },
    {
      path: '/team_students_group_list',
      name: 'team_students_group_list',
      component: TeamStudentsGroupList,
      meta: {
        title: '发布成绩|成绩发布|查分|查成绩|快查成绩|成绩导入系统'
      }
    },

    {
      path: '/team_students_group_new',
      name: 'team_students_group_new',
      component: TeamStudentsGroupNew,
      meta: {
        title: '发布成绩|成绩发布|查分|查成绩|快查成绩|成绩导入系统'
      }
    },

    {
      path: '/team_students_group_detail',
      name: 'team_students_group_detail',
      component: TeamStudentsGroupDetail,
      meta: {
        title: '发布成绩|成绩发布|查分|查成绩|快查成绩|成绩导入系统'
      }
    },
    {
      path: '/team_student_import_anyfile',
      name: 'team_student_import_anyfile',
      component: TeamStudentImportAnyFile,
      meta: {
        title: '发布成绩|成绩发布|查分|查成绩|快查成绩|成绩导入系统'
      }
    },
    {
      path: '/team_student_excel_preview',
      name: 'team_student_excel_preview',
      component: TeamStudentExcelPreview,
      meta: {
        title: '发布成绩|成绩发布|查分|查成绩|快查成绩|成绩导入系统'
      }
    },
    {
      path: '/team_student_excel_final_preview',
      name: 'team_student_excel_final_preview',
      component: TeamStudentExcelFinalPreview,
      meta: {
        title: '发布成绩|成绩发布|查分|查成绩|快查成绩|成绩导入系统'
      }
    },
    {
      path: '/exam_edit_html',
      name: 'exam_edit_html',
      component: ExamEditHtml,
      meta: {
        title: '发布成绩|成绩发布|查分|查成绩|快查成绩|成绩导入系统'
      }
    },
    {
      path: '/exam_score_import_anyfile',
      name: 'exam_score_import_anyfile',
      component: ExamScoreImportAnyfile,
      meta: {
        title: '发布成绩|成绩发布|查分|查成绩|快查成绩|成绩导入系统'
      }
    },
    {
      path: '/exam_score_excel_preview',
      name: 'exam_score_excel_preview',
      component: ExamScoreExcelPreview,
      meta: {
        title: '发布成绩|成绩发布|查分|查成绩|快查成绩|成绩导入系统'
      }
    },
    {
      path: '/exam_score_excel_final_preview',
      name: 'exam_score_excel_final_preview',
      component: ExamScoreExcelFinalPreview,
      meta: {
        title: '发布成绩|成绩发布|查分|查成绩|快查成绩|成绩导入系统'
      }
    },

    //合并成绩单
    {
      path: '/merge_exam_read_me',
      name: 'merge_exam_read_me',
      component: MergeExamReadMe,
      meta: {
        title: '发布成绩|成绩发布|查分|查成绩|快查成绩|成绩导入系统'
      }
    },
    {
      path: '/team_exam_import_anyfile',
      name: 'team_exam_import_anyfile',
      component: TeamExamImportAnyFile,
      meta: {
        title: '发布成绩|成绩发布|查分|查成绩|快查成绩|成绩导入系统'
      }
    },
    {
      path: '/team_exam_excel_preview',
      name: 'team_exam_excel_preview',
      component: TeamExamExcelPreview,
      meta: {
        title: '发布成绩|成绩发布|查分|查成绩|快查成绩|成绩导入系统'
      }
    },
    {
      path: '/team_exam_excel_final_preview',
      name: 'team_exam_excel_final_preview',
      component: TeamExamExcelFinalPreview,
      meta: {
        title: '发布成绩|成绩发布|查分|查成绩|快查成绩|成绩导入系统'
      }
    }, {
      path: '/help_teacher_xhs',
      name: 'help_teacher_xhs',
      component: HelpTeacherXhs,
      meta: {
        title: '发布成绩|成绩发布|查分|查成绩|快查成绩|成绩导入系统'
      }
    },
    {
      path: '/short_message_setting',
      name: 'short_message_setting',
      component: ShortMessageSetting,
      meta: {
        title: '发布成绩|成绩发布|查分|查成绩|快查成绩|成绩导入系统'
      }
    },
    {
      path: '/add_to_menu',
      name: 'add_to_menu',
      component: AddToPubsite,
      meta: { title: '发布成绩|成绩发布|查分|查成绩|快查成绩|成绩导入系统' }
    },
    {
      path: '/exam_report',
      name: 'exam_report',
      component: ExamReport,
      meta: { title: '发布成绩|成绩发布|查分|查成绩|快查成绩|成绩导入系统' }
    },
    {
      path: '/competition_list',
      name: 'competition_list',
      component: CompetitionList,
      meta: { title: '发布成绩|成绩发布|查分|查成绩|快查成绩|成绩导入系统' }
    },
    {
      path: '/competition_edit',
      name: 'competition_edit',
      component: CompetitionEdit,
      meta: { title: '发布成绩|成绩发布|查分|查成绩|快查成绩|成绩导入系统' }
    },
    {
      path: '/competition_manager',
      name: 'competition_manager',
      component: CompetitionManager,
      meta: { title: '发布成绩|成绩发布|查分|查成绩|快查成绩|成绩导入系统' }
    },
    {
      path: '/competition_group_edit',
      name: 'competition_group_edit',
      component: CompetitionGroupEdit,
      meta: { title: '发布成绩|成绩发布|查分|查成绩|快查成绩|成绩导入系统' }
    }




  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js